// Generated by CoffeeScript 2.7.0
var TextArea;

import Base from './base.js';

export default TextArea = class TextArea extends Base {};
